<template>
    <currency-selector></currency-selector>
</template>

<script>
import lang from '../../shared/mixins/lang';
import CurrencySelector from './CurrencySelector.vue';

export default {
    mixins: [lang],
    components: {
        CurrencySelector,
    },
};
</script>
